import { render } from "./AdminMain.vue?vue&type=template&id=1fa39eef&scoped=true&lang=true"
import script from "./AdminMain.vue?vue&type=script&lang=js"
export * from "./AdminMain.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1fa39eef"

export default script